import * as client from '@apollo/client'
import {
  EmployeeSoftwareDetailsPageQueryDocument,
  ItManagementCreateEmployeeSoftwareMembershipDocument,
} from 'generated/resources/graphql'

interface QueryParameters {
  employeeId: number
  softwareId: string
  companyId: number
  dateFrom: string
  dateTo: string
  currency: string
}

export const useCreateEmployeeSoftwareMembership = () => {
  const [createEmployeeSoftwareMembership, { loading }] = client.useMutation(
    ItManagementCreateEmployeeSoftwareMembershipDocument
  )

  return {
    create(params: QueryParameters) {
      return createEmployeeSoftwareMembership({
        variables: { employeeId: params.employeeId, softwareId: params.softwareId },
        awaitRefetchQueries: true,
        refetchQueries: [
          {
            query: EmployeeSoftwareDetailsPageQueryDocument,
            variables: {
              companyId: params.companyId,
              employeeIds: [params.employeeId],
              dateFrom: params.dateFrom,
              dateTo: params.dateTo,
              currency: params.currency,
            },
          },
        ],
      })
    },
    loading,
  }
}
